<template>
  <el-dialog
    :title="title"
    :visible.sync="dialogFormVisible"
    style="width:850px;margin:auto;"
    @close="close"
    :close-on-click-modal="false"
  >
    <el-form ref="form" :model="form" :rules="rules" v-loading="loading" :element-loading-text="elementLoadingText">
      <div class="selectAddress">
       <table v-if="addList.length>0">
        <tr class="addressHead">
          <th class="select"></th>
          <th class="name">收货人</th>
          <th class="location">所在地区</th>
          <th class="address">详细地址</th>
          <th class="mobile">手机</th>       
        </tr>
        <tr v-for="(item,i) in addList" :key="i">
          <td>
            <el-checkbox v-model="item.checked" @change="selectAddress(item.id)" :key="'select_'+item.id" ></el-checkbox>                    
          </td>
          <td>{{item.name}}</td>
          <td>{{item.province}}{{item.city}}{{item.area}}</td>
          <td>{{item.address}}</td>
          <td>{{item.mobile}}</td>          
        </tr>
       </table>
       <img v-else src="http://img.static.knnnj.com/Default/dcb7cc98-a007-4f37-88cc-539fdaf24747.png" />
      </div>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="close">取 消</el-button>
      <el-button type="primary" @click="save">保存地址</el-button>
    </div>
  </el-dialog>
</template>
<style>
@import '../../../styles/selectAddress.css';
</style>
<script>
import { getAddressList} from '@/api/deliveryAddress'
import { changeAddress } from '@/api/order'
export default {
  name: 'SelectAddress',
  components: { },
  data() {
    return {
      addList:[],
      form: { },
      rules: { },    
      addressId:0, 
      title: '',
      elementLoadingText: '数据上传中，请稍后...',     
      loading:false,
      dialogFormVisible: false,
    }
  },
  created() {
    getAddressList().then(res => {
          if (res.data.success === true) {
            this.addList = res.data.result
          } else {
           this.addList = []
          }
        }).catch(error => {
            this.addList = []
        })
  },
  methods: {
    async showSelect(row) {
      debugger
      this.title = '切换地址'       
      this.form = row        
      this.dialogFormVisible = true
    },   
    selectAddress(id)
      {       
        this.addressId=id;
         for(var i=0;i<this.addList.length;i++)
         {          
            if(this.addList[i].id!=id)
            {             
              this.$set(this.addList[i],'checked',false)
            }
            else
            {              
              this.addressId=id;
              this.$set(this.addList[i],'checked',true)
            }
         }
      },
    close() {
      this.dialogFormVisible = false
    },
    save(){
        if(this.addressId<=0||this.addressId==undefined||this.addressId==null)
        {
          this.$message({ message: '请选择收货地址', type: 'error', customClass: 'c-msg' }) 
          return;
        }    
        changeAddress({addressId:this.addressId,orderId:this.form.id}).then(res=>{
           if(res.data.success)
           {
            this.$message({ message: "保存成功", type: 'success', customClass: 'c-msg' })         
            this.dialogFormVisible = false
            this.$emit('fetch-data')
           }
           else
           {
            this.$message({ message: res.data.error.message, type: 'error', customClass: 'c-msg' }) 
           }
        });
      },
  },
}
</script>



// WEBPACK FOOTER //
// SelectAddress.vue?43fefefd